import React from 'react';

const AddressDisplay = ({ data, onEdit, onDelete }) => (
  <div className="mt-6 p-4 bg-white rounded-lg border border-gray-200">
    <h2 className="text-xl font-semibold text-gray-800 mb-4">Alamat Penghantaran</h2>
    <div className="space-y-3">
      <div>
        <label className="text-sm font-medium text-gray-600">Nama</label>
        <p className="text-gray-800">{data.name}</p>
      </div>
      <div>
        <label className="text-sm font-medium text-gray-600">Nombor Telefon</label>
        <p className="text-gray-800">{data.phone}</p>
      </div>
      <div>
        <label className="text-sm font-medium text-gray-600">Alamat</label>
        <p className="text-gray-800 whitespace-pre-line">{data.address}</p>
      </div>
      <div className="flex space-x-4 pt-4">
        <button
          onClick={onEdit}
          className="flex-1 py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Edit
        </button>
        <button
          onClick={onDelete}
          className="flex-1 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
);

export default AddressDisplay;
